import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile(breakpoint?: number) {
  const bp = breakpoint ?? MOBILE_BREAKPOINT
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${bp - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < bp)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(window.innerWidth < bp)
    return () => mql.removeEventListener("change", onChange)
  }, [bp])

  return !!isMobile
}
